import { render, staticRenderFns } from "./StatsWidget.vue?vue&type=template&id=5d5cdb9b&scoped=true"
import script from "./StatsWidget.vue?vue&type=script&lang=js"
export * from "./StatsWidget.vue?vue&type=script&lang=js"
import style0 from "./StatsWidget.vue?vue&type=style&index=0&id=5d5cdb9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5cdb9b",
  null
  
)

export default component.exports